
<mat-accordion *ngIf="broadcastMessages" class="broadcasts">
    <mat-expansion-panel *ngFor="let broadcast of broadcastMessages" class="broadcast"
                         [class.critical-message]="broadcast.BroadcastType === 1"
                         [class.warning-message]="broadcast.BroadcastType === 2"
                         [class.info-message]="broadcast.BroadcastType === 3"
                         [expanded]="false"
                         hideToggle>

        <mat-expansion-panel-header collapsedHeight="4rem" [attr.aria-label]="broadcast.Title" class="broadcast-expansion-panel-header">
            <mat-panel-title>
                <div class="container broadcast-header">
                    <div class="row">
                        <div class="col">
                            <div class="bolder broadcast-header-text">
                                <span *ngIf="broadcast.BroadcastType === 1">
                                    <ng-container *appFeatureToggle="'showMessageBroadcastCriticalLabel'" class="broadcast-critical-label">
                                        <span class="text-uppercase" i18n-aria-label="@@critical-alert" aria-label="Critical alert" i18n="broadcasts critical@@broadcasts-critical">Critical</span>
                                        <span class="mr-2 ml-2">|</span>
                                    </ng-container>
                                </span>
                                <span *ngIf="broadcast.BroadcastType === 2">
                                    <ng-container *appFeatureToggle="'showMessageBroadcastWarningLabel'" class="broadcast-warning-label">
                                        <span class="text-uppercase" i18n-aria-label="@@warning-alert" aria-label="Warning alert" i18n="broadcasts warning@@broadcasts-warning">Warning</span>
                                        <span class="mr-2 ml-2">|</span>
                                    </ng-container>
                                </span>
                                <span *ngIf="broadcast.BroadcastType === 3">
                                    <ng-container *appFeatureToggle="'showMessageBroadcastInformationLabel'" class="broadcast-information-label">
                                        <span class="text-uppercase" i18n-aria-label="@@information-alert" aria-label="Information alert" i18n="broadcasts information@@broadcasts-information">Information</span>
                                        <span class="mr-2 ml-2">|</span>
                                    </ng-container>
                                </span>
                                <span title="{{broadcast.Title}}">{{broadcast.Title}}</span>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="broadcast-expander">
                                <i class="ms-Icon ms-Icon--ChevronDown" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="container message-content">
            <div class="row">
                <div class="col">
                    <p>{{broadcast.Message}}</p>
                    <i *ngIf="broadcast.LinkUrl" class="fa fa-link mr-2" aria-hidden="true"></i>
                    <a *ngIf="broadcast.LinkUrl" href="{{broadcast.LinkUrl}}" class="broadcast-link-url">
                        <span class="mr-2">
                            {{broadcast.LinkText ? broadcast.LinkText : broadcast.LinkUrl}}
                        </span>
                    </a>
                </div>
            </div>
            <div class="message-info row mb-3 mt-3 justify-content-between">
                <div class="col">
                    <span class="message-info-date" *ngIf="broadcast.StartDateAsDate || broadcast.EndDateAsDate">
                        <span *ngIf="broadcast.StartDateAsDate">{{broadcast.StartDateAsDate | date:'short'}}</span>
                        <span *ngIf="broadcast.StartDateAsDate || broadcast.EndDateAsDate"> - </span>
                        <span *ngIf="broadcast.EndDateAsDate">{{broadcast.EndDateAsDate | date:'short'}}</span>
                    </span>
                </div>
                <div class="col-auto">
                    <button mat-stroked-button class="close-broadcast-btn" (click)="hide(broadcast.Id)" *ngIf="showHideButton">
                        <i class="fa fa-times mr-1" aria-hidden="true"></i>
                        <span i18n="broadcasts close button@@broadcasts-close-button">Close & remove</span>
                    </button>
                    <button mat-stroked-button class="close-broadcast-btn ml-3" [routerLink]="['',{ outlets: { modal: ['broadcast-messages','edit',broadcast.Id] } }]"
                       *ngIf="hasPermissionEditorOrAdmin$ | async" (click)="whenEditBtnClicked()">
                        <i class="fa fa-pencil mr-1" aria-hidden="true"></i>
                        <span i18n="broadcasts edit button@@broadcasts-edit-button">Edit</span>
                    </button>
                </div>
            </div>
        </div>
    </mat-expansion-panel>
</mat-accordion>
